import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService } from '../service/auth/auth.service';
import { AdminRestService, AntifraudEventRow, AntifraudSummary } from '../service/rest/admin-rest.service';

@Component({
  selector: 'app-admin-antifraud',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './admin-antifraud.component.html',
  styleUrl: './admin-antifraud.component.css'
})
export class AdminAntifraudComponent implements OnInit {
  sessionId = '';
  loading = false;
  error = '';
  summary: AntifraudSummary | null = null;
  events: AntifraudEventRow[] = [];
  page = 0;
  size = 20;
  totalElements = 0;
  totalPages = 0;
  statusFilter = 'open';
  signalFilter = '';
  updatingId: number | null = null;

  constructor(
    private authService: AuthService,
    private adminRest: AdminRestService
  ) {}

  ngOnInit() {
    this.sessionId = this.authService.getUser()?.sid || '';
    void this.load();
  }

  async load() {
    if (!this.sessionId) return;
    this.loading = true;
    this.error = '';
    try {
      const [summary, page] = await Promise.all([
        this.adminRest.getAntifraudSummary(this.sessionId),
        this.adminRest.getAntifraudEvents(
          this.sessionId,
          this.page,
          this.size,
          this.statusFilter || undefined,
          this.signalFilter || undefined
        )
      ]);
      this.summary = summary;
      this.events = page?.content ?? [];
      this.totalElements = page?.totalElements ?? 0;
      this.totalPages = page?.totalPages ?? 0;
    } catch (e: any) {
      this.error = e?.message || 'Failed to load fraud signals';
    } finally {
      this.loading = false;
    }
  }

  async setStatus(event: AntifraudEventRow, status: 'resolved' | 'ignored' | 'open') {
    if (!this.sessionId) return;
    this.updatingId = event.id;
    try {
      const updated = await this.adminRest.patchAntifraudEvent(this.sessionId, event.id, status);
      if (updated) {
        await this.load();
      }
    } finally {
      this.updatingId = null;
    }
  }

  onFilterChange() {
    this.page = 0;
    void this.load();
  }

  signalLabel(signal: string): string {
    if (signal === 'ACCOUNT_SHARING') return 'Account sharing';
    if (signal === 'CONTENT_SCRAPE') return 'Content scraping';
    if (signal === 'ROBOT_REQUEST') return 'Robot-like requests';
    return signal;
  }
}
